class LogoCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    setTimeout(() => {
      const logos = this.querySelector('.logos');
      const logoItems = Array.from(this.querySelectorAll('.logo'));
      const clonedItems = logoItems.map(el => el.cloneNode(true));
      logos.append(...clonedItems);
      const count = logos.childElementCount;
      logos.setAttribute('style', `--duration-m: ${Math.round(count*1.55)}s; --duration-t: ${count*2}s; --duration-d: ${count*2.5}s; `);
      console.log('logos.childElementCount', logos.childElementCount);
    }, 20);
  }

}

customElements.define('logo-carousel', LogoCarousel);